module.exports = __webpack_public_path__ + "img/tuiguang3-2-4.6486d574.png";